(function () {
  'use strict';

  /* @ngdoc object
   * @name wbBanner
   * @description
   *
   */
  angular
    .module('wbBanner', [
      'wbResource'
    ]);
}());
